export default "__VITE_ASSET__3274ab11__"